import axios from 'axios';
import _get from 'lodash/get';
import _isUndefined from 'lodash/isUndefined';
import { API, HTTP, RESPONSES } from 'utils/constants';
import { metricsElementTag } from '../utils/coremetrics';

const { CONTENT_TYPE, APP_JSON, SUCCESS_CODE } = HTTP;

const hasErrors = (statusCode, errors) =>
    !_isUndefined(statusCode) && statusCode !== '0' && !_isUndefined(errors) && errors.length >= 1;

export async function validatePin(tempUserId, pinNbr) {
    try {
        const res = await axios.post(
            API.VALIDATE_PIN,
            { tempUserId, pinNbr },
            {
                headers: { [CONTENT_TYPE]: APP_JSON }
            }
        );
        const {
            data,
            operationStatus: { statusCode }
        } = _get(res, 'data', {});
        return statusCode === SUCCESS_CODE ? { data } : RESPONSES.ERROR_404;
    } catch (e) {
        if (hasErrors(e?.response?.data?.operationStatus?.statusCode, e?.response?.data?.errors)) {
            metricsElementTag(e.response.data.errors[0].message, true);
            return { errors: e.response.data.errors };
        }
        return RESPONSES.ERROR_504;
    }
}

export async function getEnvProperties() {
    try {
        const res = await axios.get(API.ENV_PROPS, {
            headers: { [CONTENT_TYPE]: APP_JSON }
        });
        return _get(res, 'data', null);
    } catch (e) {
        return RESPONSES.ERROR_504;
    }
}

export async function getPhoneTypeCodes() {
    try {
        const res = await axios.get(API.PHONE_CODES_ENDPOINT, {
            headers: { [CONTENT_TYPE]: APP_JSON }
        });
        return _get(res, 'data', null);
    } catch (e) {
        return RESPONSES.ERROR_504;
    }
}

export async function getBusRelationshipCodes() {
    try {
        const res = await axios.get(API.BUS_REL_ENDPOINT, {
            headers: { [CONTENT_TYPE]: APP_JSON }
        });
        return _get(res, 'data', null);
    } catch (e) {
        return RESPONSES.ERROR_504;
    }
}

export async function getSecurityQuestions() {
    try {
        const res = await axios.get(API.SECURITY_QUESTIONS, {
            headers: { [CONTENT_TYPE]: APP_JSON }
        });
        return _get(res, 'data', null);
    } catch (e) {
        return RESPONSES.ERROR_504;
    }
}

export async function validateProfile({
    accountNbr,
    businessRelationshipTypeCd,
    businessNm,
    emailAddressTxt,
    firstNm,
    lastNm,
    jobTitleTxt,
    userId,
    passwordTxt,
    phoneNbr,
    phoneTypeCd,
    securityQuestions,
    delegateId,
    tempPin
}) {
    try {
        const res = await axios.post(
            API.VALIDATE_PROFILE,
            {
                accountNbr,
                businessRelationshipTypeCd,
                businessNm,
                emailAddressTxt,
                firstNm,
                lastNm,
                jobTitleTxt,
                userId,
                passwordTxt,
                phoneNbr,
                phoneTypeCd,
                securityQuestions,
                delegateId,
                tempPin
            },
            {
                headers: { [CONTENT_TYPE]: APP_JSON }
            }
        );
        const {
            data,
            operationStatus: { statusCode }
        } = _get(res, 'data', {});
        return statusCode === SUCCESS_CODE ? { data } : RESPONSES.ERROR_404;
    } catch (e) {
        if (hasErrors(e?.response?.data?.operationStatus?.statusCode, e?.response?.data?.errors)) {
            metricsElementTag(e.response.data.errors[0].message, true);
            return { errors: e.response.data.errors };
        }
        return RESPONSES.ERROR_504;
    }
}

export function getTealiumHeaders() {
    return getTealiumConfig().then(({ headers: tealiumHeaders }) => {
        if (tealiumHeaders) {
            return tealiumHeaders;
        }
    });
}

function getTealiumConfig() {
    try {
        return axios.get('/register/tealium-config', {
            headers: { [CONTENT_TYPE]: APP_JSON }
        });
    } catch (e) {
        console.log('Unable to fetch Tealium configuration details. Please try again later.', e);
        return RESPONSES.ERROR_504;
    }
}
